import { useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function Account() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setMsg("");
    if (next.length < 8) {
      setErr("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      setErr("New password and confirmation do not match.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      setMsg("Password updated. Use the new password next time you sign in.");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Could not update password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-account" className="max-w-xl">
      <p className="overline text-[#C9A050]/70 mb-3">Account</p>
      <h1 className="font-display text-3xl md:text-4xl tracking-tight mb-2">
        Change password
      </h1>
      <p className="text-[#8A8A93] text-sm mb-10">
        Signed in as {user?.email}. Once changed, the new password persists across
        backend restarts even if the .env value is different.
      </p>

      <form onSubmit={submit} className="space-y-6">
        <Field
          label="Current password"
          value={current}
          onChange={setCurrent}
          testid="acc-current"
        />
        <Field
          label="New password"
          value={next}
          onChange={setNext}
          testid="acc-new"
          hint="At least 8 characters."
        />
        <Field
          label="Confirm new password"
          value={confirm}
          onChange={setConfirm}
          testid="acc-confirm"
        />

        {err && (
          <p data-testid="acc-error" className="text-[#FF8B8B] text-sm">
            {err}
          </p>
        )}
        {msg && (
          <p data-testid="acc-success" className="text-[#C9A050] text-sm">
            {msg}
          </p>
        )}

        <button
          type="submit"
          disabled={busy || !current || !next || !confirm}
          data-testid="acc-submit"
          className="overline border border-[#C9A050] text-[#C9A050] hover:bg-[#C9A050] hover:text-black px-6 py-3 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, testid, hint }) {
  return (
    <div>
      <label className="overline block mb-2">{label}</label>
      <input
        type="password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        autoComplete="new-password"
        className="w-full bg-transparent border-b border-white/15 focus:border-[#C9A050] py-2 text-white outline-none transition-colors"
      />
      {hint && <p className="text-xs text-[#8A8A93] mt-2">{hint}</p>}
    </div>
  );
}
